(() => {
  'use strict';
  if (window.__phUXV3Loaded) return;
  window.__phUXV3Loaded = true;
  window.__phIn3MessagingInitialised = true;
  let config = {};
  const configNode = document.getElementById('ph-ux-v3-config');
  try { config = JSON.parse(configNode ? configNode.textContent : '{}'); } catch (_) { return; }
  const lang = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
  const copy = {
    nl: {shipping:'Verzending',checkout:'Berekend bij het afrekenen',countries:'Toon levertijden voor',all:'Alle landen',extra:'Aanvullende producten'},
    de: {shipping:'Versand',checkout:'Berechnung an der Kasse',countries:'Lieferzeiten anzeigen für',all:'Alle Länder',extra:'Ergänzende Produkte'},
    fr: {shipping:'Livraison',checkout:'Calculée en caisse',countries:'Afficher les délais pour',all:'Tous les pays',extra:'Produits complémentaires'},
    pl: {shipping:'Dostawa',checkout:'Obliczana w kasie',countries:'Pokaż terminy dostawy do',all:'Wszystkie kraje',extra:'Produkty uzupełniające'},
    en: {shipping:'Delivery',checkout:'Calculated at checkout',countries:'Show delivery times for',all:'All countries',extra:'Complementary products'}
  };
  const text = copy[lang] || copy.nl;
  const prefix = String(config.root || '/').replace(/\/$/, '');
  const hosts = new Set([location.hostname,'www.prohaar.nl','prohaar.nl']);
  function repairLinks(root = document) {
    root.querySelectorAll('a[href]').forEach(a => {
      if (a.matches('[hreflang],[data-language],[data-locale]') || a.closest('[data-localization],.localization-form')) return;
      let url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
      if (!hosts.has(url.hostname) || !/^https?:$/.test(url.protocol)) return;
      if (prefix && /^\/(collections|products|pages|blogs|policies)(\/|$)/.test(url.pathname)) a.setAttribute('href',prefix + url.pathname + url.search + url.hash);
    });
    root.querySelectorAll('a:not([href])').forEach(a => {
      if (a.textContent.trim().toLowerCase() === 'info@prohaar.nl') a.href = 'mailto:info@prohaar.nl';
    });
  }
  function addComplementaryHeading() {
    document.querySelectorAll('.block-ph_complementary.product-recommendations').forEach(box => {
      if (!box.querySelector('.l4cl li') || box.querySelector('[data-ph-complementary-heading]')) return;
      const heading = document.createElement('p'); heading.dataset.phComplementaryHeading = '';
      const strong = document.createElement('strong'); strong.textContent = text.extra;
      heading.appendChild(strong); box.prepend(heading);
    });
  }
  // Storefront messaging only. Checkout payment providers and payment logos are untouched.
  function removeRetiredMessaging() {
    document.querySelectorAll('klarna-placement').forEach(el => {
      const block = el.closest('.shopify-block');
      (block || el).hidden = true;
    });
    document.querySelectorAll('#ph-in3-message,.ph-in3-message,.ph-free-shipping,.form-cart .l4tt > li.strong.overlay-lime,#cart .l4tt > li.strong.overlay-lime').forEach(el => el.remove());
    // Stop gift-threshold upsells from substituting a delivery calculation.
    document.querySelectorAll('.cart-upsell').forEach(box => {
      box.dataset.phGap = '0';
      box.removeAttribute('data-ph-gap-heading');
      box.classList.remove('ph-smart-gap');
      const heading = box.querySelector('h3');
      if (heading && heading.textContent !== text.extra) heading.textContent = text.extra;
    });
  }
  function enhanceShippingTables() {
    if (config.pageHandle !== 'shipping-info' || document.getElementById('ph-country-filter')) return;
    const tables = Array.from(document.querySelectorAll('#content table')).filter(t => t.tBodies.length && t.tBodies[0].rows.length > 5);
    if (!tables.length) return;
    const form = document.createElement('div'); form.className = 'ph-country-filter';
    const label = document.createElement('label'); label.htmlFor = 'ph-country-filter'; label.textContent = text.countries;
    const select = document.createElement('select'); select.id = 'ph-country-filter'; select.setAttribute('aria-label',text.countries);
    select.add(new Option(text.all,''));
    Array.from(tables[0].tBodies[0].rows).forEach(row => { const name = row.cells[0].textContent.trim(); select.add(new Option(name,name)); });
    form.append(label,select); tables[0].parentElement.before(form);
    tables.forEach(table => {
      const headers = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent.trim());
      Array.from(table.tBodies[0].rows).forEach(row => Array.from(row.cells).forEach((cell,i) => { cell.dataset.phLabel = headers[i] || ''; }));
      table.classList.add('ph-shipping-table');
    });
    select.addEventListener('change',() => tables.forEach(table => Array.from(table.tBodies[0].rows).forEach(row => { row.hidden = !!select.value && row.cells[0].textContent.trim() !== select.value; })));
  }
  function restoreShippingTotalRow() {
    document.querySelectorAll('.form-cart .l4tt,#cart .l4tt').forEach(list => {
      if (list.querySelector('[data-ph-shipping-cost-note]')) return;
      const row = document.createElement('li'); row.dataset.phShippingCostNote = ''; row.className = 'ph-delivery-row';
      const label = document.createElement('span'); label.textContent = text.shipping;
      const link = document.createElement('a'); link.textContent = text.checkout; link.href = config.shippingUrl || prefix + '/pages/shipping-info';
      row.append(label,link);
      list.insertBefore(row,list.querySelector(':scope > li.strong.mobile-hide'));
    });
  }
  function refresh() { removeRetiredMessaging(); repairLinks(); addComplementaryHeading(); enhanceShippingTables(); restoreShippingTotalRow(); }
  function start() {
    refresh();
    document.addEventListener('click',event => {
      const target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
      if (!target || !target.closest('[data-ph-product-details]')) return;
      const section = Array.from(document.querySelectorAll('[id="section-info"]')).find(el => el.getClientRects().length > 0);
      if (!section) return;
      event.preventDefault();
      const details = section.closest('details'); if (details) details.open = true;
      section.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      section.setAttribute('tabindex','-1'); section.focus({preventScroll:true});
    });
    let timer;
    const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh,100); };
    ['themeVariantUpdated','themeCartUpdated','themeCartOpened','shopify:section:load','phCartRecommendationsLoaded'].forEach(name => {
      window.addEventListener(name,removeRetiredMessaging,true);
      window.addEventListener(name,schedule); document.addEventListener(name,schedule);
    });
    const watched = 'klarna-placement,#ph-in3-message,.ph-in3-message,.ph-free-shipping,.cart-upsell,.l4tt,.block-ph_complementary';
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(watched) || node.querySelector(watched))))) schedule();
    }).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
